import React from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import {TextMedium14} from "@/app/components/texts";

interface ChipProps {
  text?: string | number | undefined;
  className?: string;
  child?: React.ReactNode;
  isActive?: boolean
  isSecondaryWhite?: boolean
  isBig?: boolean
  onClick?: () => void
}

const Chip: React.FC<ChipProps> = ({text, className, child, isActive, isSecondaryWhite, onClick, isBig = false}) => (
  <div onClick={onClick}
       className={classNames({[styles.isButton]: onClick !== undefined}, {[styles.secondaryWhite]: isSecondaryWhite})}>
    {text === undefined ? <div
        className={classNames(styles.chip, {[styles.active]: isActive}, {[styles.big]: isBig}, className)}>
        {child}
      </div> :
      <TextMedium14 text={text?.toString()}
                    className={classNames(styles.chip, {[styles.active]: isActive}, className, {[styles.secondaryWhite]: isSecondaryWhite}, {[styles.big]: isBig})}/>}
  </div>
);

export default Chip;